module.exports = __webpack_public_path__ + "static/img/copy-orderNo.7aac41eb.svg";